import { gql } from '@apollo/client';

export const GET_USER_REVIEWS = gql`
  query GetUserReviews($revieweeId: ID!, $limit: Int, $nextToken: String) {
    listReviews(
      filter: {
        revieweeId: {eq: $revieweeId}
      }, 
      limit: $limit, 
      nextToken: $nextToken
    ) {
      items {
        id
        rating
        content
        communicationRating
        createdAt
        reviewerId
        reviewer {
          id
          firstName
          profilePicture
        }
        reviewType
        bookingId
      }
      nextToken
    }
  }
`;

export const GET_STUDIO_REVIEWS = gql`
  query GetStudioReviews($studioId: ID!, $limit: Int, $nextToken: String) {
    listReviews(filter: {studioId: {eq: $studioId}, reviewType: {eq: HOST_REVIEW}}, limit: $limit, nextToken: $nextToken) {
      items {
        id
        rating
        content
        communicationRating
        createdAt
        reviewerId
        reviewer {
          id
          firstName
          profilePicture
        }
      }
      nextToken
    }
  }
`;